import type { ConversationNodeMessengerUrlRouting } from 'lib-shared-types-api';

type RoutedThroughMessengerUrlRoutingProps = {
  node: ConversationNodeMessengerUrlRouting;
};

export function RoutedThroughMessengerUrlRouting({
  node,
}: RoutedThroughMessengerUrlRoutingProps): JSX.Element {
  return (
    <>
      Url Trigger ·{' '}
      {node.match_value && (
        <>
          Routed via <strong>{node.match_value}</strong>
        </>
      )}
    </>
  );
}
